import { Roles } from "../../../../constants/roles";

type FacebookPluginPostOptions = {
    showText?: boolean;
    width?: number;
};

function buildFacebookPluginPostIframeSrc(url: string, options: FacebookPluginPostOptions = {}): string | null {
    const raw = String(url || "").trim();
    if (!raw) return null;

    const showText = options.showText !== false;
    const widthQuery = typeof options.width === "number" ? `&width=${options.width}` : "";

    return `https://www.facebook.com/plugins/post.php?href=${encodeURIComponent(raw)}&show_text=${showText ? "true" : "false"}${widthQuery}`;
}

function buildFacebookEmbedNode(
    url: string,
    options: { width?: number; height?: number; showText?: boolean } = {},
): HTMLElement | null {
    try {
        const src = buildFacebookPluginPostIframeSrc(url, {
            showText: options.showText,
            width: options.width,
        });
        if (!src) return null;

        const container = document.createElement("div");
        container.className = "sns-embed facebook-embed";
        container.setAttribute("data-role", Roles.SNS_EMBED);
        container.style.cssText = "margin-bottom: 16px; margin-top: 16px;";

        const iframe = document.createElement("iframe");
        iframe.src = src;
        iframe.width = String(typeof options.width === "number" ? options.width : 500);
        iframe.height = String(typeof options.height === "number" ? options.height : 600);
        iframe.style.cssText = "border:none;overflow:hidden;max-width:100%;";
        iframe.scrolling = "no";
        iframe.frameBorder = "0";
        iframe.allowFullscreen = true;
        iframe.loading = "lazy";
        iframe.setAttribute("sandbox", "allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox");
        iframe.referrerPolicy = "strict-origin-when-cross-origin";
        iframe.setAttribute("allow", "autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share");
        container.appendChild(iframe);

        return container;
    } catch (e) {
        console.error("buildFacebookEmbedNode failed", e);
        return null;
    }
}

export { buildFacebookPluginPostIframeSrc, buildFacebookEmbedNode };
